<script>

export default {
  name: "SlGroupStats",
  props: {
    slGroup: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    initGroup() {

    }
  },
  watch: {
    slGroup: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal !== null) {
            this.initGroup();
          }
        }
      },
      immediate: true
    },
  }
}
</script>

<template>
  <div class="card">
    <div class="card-body">
      <h3 class="mb-2 card-title text-primary">{{ slGroup.name }}</h3>
      <p class="mb-4 card-title-desc font-size-14 text-muted fst-italic">{{ slGroup.description || "-"}}</p>
      <hr>
      <b-list-group class="mt-1 mb-1" flush>
        <b-list-group-item class="align-items-center">
          <b class="text-muted">Leads</b>
          <span class="badge bg-warning font-size-12 text-dark float-end">{{ slGroup.leads }}</span>
        </b-list-group-item>
        <b-list-group-item class="align-items-center">
          <b class="text-muted">Payments</b>
          <span class="badge bg-success font-size-12 text-light float-end ">{{ slGroup.perf }}%</span>
          <span class="float-end font-size-12 text-success me-2">{{ slGroup.paid }}</span>
        </b-list-group-item>
        <b-list-group-item class="align-items-center">
          <b class="text-muted">Renews</b>
          <span class="badge bg-info font-size-12 text-light float-end">{{ slGroup.perf_renew }}%</span>
          <span class="float-end font-size-12 text-info me-2">{{ slGroup.paid_renews }}</span>
        </b-list-group-item>
        <b-list-group-item class="align-items-center">
          <b class="text-muted">Result HT</b>
          <span class="font-size-12 text-dark fw-bold float-end">{{ slGroup.ca }}€</span>
        </b-list-group-item>

      </b-list-group>

      <h5 class="mt-3 font-size-12">Currencies</h5>
      <hr>
      <b-list-group class="mt-1 mb-1" flush>
        <b-list-group-item class="align-items-center" v-for="currency in slGroup.currencies" :key="currency.currency">
          <div v-b-toggle="'collapse-currency'+currency.currency">
            <b class="text-muted">{{ currency.currency }}</b>
            <span class="badge bg-dark font-size-12 text-white float-end">{{ currency.amountTotalHT / 100}} HT</span>
            <span class="font-size-12 text-dark float-end me-2">{{ currency.amountTotal / 100}}</span>
          </div>
          <b-collapse :id="'collapse-currency'+currency.currency">
            <table
                class="table project-list-table table-nowrap table-centered align-middle"
            >
              <thead class="table-light">
              <tr>
                <th scope="col">First</th>
                <th scope="col">Renews</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="text-success">
                  {{ currency.first}}
                  <br><span class="badge font-size-13 bg-success text-white">{{ currency.firstAmountHT / 100}} HT</span>
                  <br><small>{{ currency.firstAmount / 100}} TTC</small>
                </td>
                <td class="text-info">
                  {{ currency.renews}}
                  <br><span class="badge font-size-13 bg-info text-white">{{ currency.renewsAmountHT / 100}} HT</span>
                  <br><small>{{ currency.renewsAmount / 100}} TTC</small>
                </td>
              </tr>
              </tbody>
            </table>
          </b-collapse>
        </b-list-group-item>
      </b-list-group>


      <h5 class="mt-3 font-size-12" v-b-toggle="'collapse-products'+slGroup.name">Products</h5>
      <hr>
      <b-collapse :id="'collapse-products'+slGroup.name">
        <div class="table-responsive">
          <table
              class="table project-list-table table-nowrap table-centered align-middle"
          >
            <thead class="table-light">
              <tr>
                <th scope="col">Product</th>
                <th>Payments</th>
                <th>Renews</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="product in slGroup.products" :key="product.name">
                <td><span class="text-dark fw-medium">{{ product.name }}</span></td>
                <td><span class="text-success fw-medium">{{ product.first }}</span></td>
                <td><span class="text-info fw-medium">{{ product.renews }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-collapse>

    </div>
  </div>
</template>

<style scoped>

</style>
